export default {"src":"/_next/static/media/circle_arrow.0a578b3a.svg","height":26,"width":26};